import { Country, Language } from './lists.model';
import { Organisation } from './organisation.model';
import { Role } from './role.model';

export class User {
  id: number;
  login: string;
  email: string;
  email2: string;
  lastName: string;
  firstName: string;
  address: string;
  addressExtra: string;
  city: string;
  country: Country;
  mobile: string;
  phone: string;
  fax: string;
  accountType: number;
  roles: Role[];

  password: string;

  languageCode: string;

  organisation: Organisation;
  advisor: User;

  languageGui: Language;
  languagePdf: Language;

  enabled: boolean;
  disabeldAt: Date;

  createdAt: Date;
  updatedAt: Date;
}
